import { areRequiredFieldsSet } from "@/utility/requiredFieldsSet";
import { isEqual } from "lodash";

export default {
  data() {
    return {
      isLoading: false,
      requiredFieldsSet: false,
      // Determines if form was submitted at least once (triggers validation)
      submitAttempted: false,
      formOriginalState: {},
      isDirtyForm: false,
    };
  },
  watch: {
    form: {
      handler(formValues) {
        // If all the required fields have values set, we allow the form to be submitted; Else we prevent the form submit action.
        this.requiredFieldsSet = areRequiredFieldsSet(formValues, this.requiredFormFields);
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    // Converting to string to remove internal properties
    this.formOriginalState = JSON.stringify(this.form);
    // We need watcher here in mounted because in beforeMount hook form has a lot changes and only after that we have to watching form prop
    this.$watch(
      vm => [vm.form, vm.formOriginalState],
      ([form, originalState]) => {
        this.isDirtyForm = !isEqual(originalState, JSON.stringify(form));
        this.$emit("isDirtyForm", this.isDirtyForm);
      },
      { deep: true },
    );
  },
  methods: {
    beforeSave() {
      this.isLoading = true;
    },
    afterSave() {
      this.isLoading = false;
      // Reset form original state
      this.formOriginalState = JSON.stringify(this.form);
      this.$emit("isDirtyForm", false);
    },
    // Call this function whenever a first attempt to save a form happens
    setSubmitAttempted() {
      this.submitAttempted = true;
    },
  },
};
